module.exports = __webpack_public_path__ + "media/images/logo_e_bilet_black-48bc24bd89fcbd75ac26b9d32bf1cd00.svg";